import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarCylinder = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.88025 0.707094L13.2399 10.0587C13.9437 11.3946 11.4806 13.9962 10.0731 13.2227L0.713455 3.87116M3.88025 0.707094C4.65436 1.76178 1.69868 4.50397 0.713455 3.87116M3.88025 0.707094C2.82466 0.144599 0.150493 3.09773 0.713455 3.87116",
		stroke: "white"
	})]
});
export default SvgToolbarCylinder;
